import * as leaveTypes from "../../types/admin/leaveTypes";

export const addLeaveReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_OF_USERS_REQUEST:
      return {
        ...state,
        addLeaveLoading: true,
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_SUCCESS:
      return {
        ...state,
        addLeaveLoading: false,
        addLeaveInfo: payload,
        addLeaveErrors: "",
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_FAIL:
      return {
        ...state,
        addLeaveLoading: false,
        addLeaveErrors: payload,
        addLeaveInfo: [],
      };
    default:
      return state;
  }
};

export const getLeaveByCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_LEAVE_OF_USERS_BY_COMPANY_REQUEST:
      return {
        ...state,
        getLeaveByUserLoadings: true,
      };
    case leaveTypes.GET_LEAVE_OF_USERS_BY_COMPANY_SUCCESS:
      return {
        ...state,
        getLeaveByUserLoadings: false,
        getLeaveByUserInfo: payload,
        getLeaveByUserErrors: "",
      };
    case leaveTypes.GET_LEAVE_OF_USERS_BY_COMPANY_FAIL:
      return {
        ...state,
        getLeaveByUserLoadings: false,
        getLeaveByUserErrors: payload,
        getLeaveByUserInfo: [],
      };
    default:
      return state;
  }
};

export const getLeaveByIdReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_LEAVE_OF_USERS_BY_ID_REQUEST:
      return {
        ...state,
        getLeaveByCompLoadings: true,
      };
    case leaveTypes.GET_LEAVE_OF_USERS_BY_ID_SUCCESS:
      return {
        ...state,
        getLeaveByCompLoadings: false,
        getLeaveByCompInfo: payload,
        getLeaveByCompErrors: "",
      };
    case leaveTypes.GET_LEAVE_OF_USERS_BY_ID_FAIL:
      return {
        ...state,
        getLeaveByCompLoadings: false,
        getLeaveByCompErrors: payload,
        getLeaveByCompInfo: [],
      };
    default:
      return state;
  }
};

export const deleteLeaveReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.DELETE_LEAVE_OF_USERS_REQUEST:
      return {
        ...state,
        deleteLeaveLoadings: true,
      };
    case leaveTypes.DELETE_LEAVE_OF_USERS_SUCCESS:
      return {
        ...state,
        deleteLeaveLoadings: false,
        deleteLeaveInfo: payload,
        deleteLeaveErrors: "",
      };
    case leaveTypes.DELETE_LEAVE_OF_USERS_FAIL:
      return {
        ...state,
        deleteLeaveLoadings: false,
        deleteLeaveErrors: payload,
        deleteLeaveInfo: [],
      };
    default:
      return state;
  }
};

export const addApproveLeaveReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_OF_USERS_APPROVE_REQUEST:
      return {
        ...state,
        approveLeaveLoadings: true,
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_APPROVE_SUCCESS:
      return {
        ...state,
        approveLeavelLoadings: false,
        approveLeavelInfo: payload,
        approveLeavelErrors: "",
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_APPROVE_FAIL:
      return {
        ...state,
        approveLeavelLoadings: false,
        approveLeavelErrors: payload,
        approveLeavelInfo: [],
      };
    default:
      return state;
  }
};

export const addRejectLeaveReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_OF_USERS_REJECT_REQUEST:
      return {
        ...state,
        rejectLeaveLoadings: true,
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_REJECT_SUCCESS:
      return {
        ...state,
        rejectLeavelLoadings: false,
        rejectLeavelInfo: payload,
        rejectLeavelErrors: "",
      };
    case leaveTypes.ADD_LEAVE_OF_USERS_REJECT_FAIL:
      return {
        ...state,
        rejectLeavelLoadings: false,
        rejectLeavelErrors: payload,
        rejectLeavelInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyLeaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST:
      return {
        ...state,
        comLeaveSettLoadings: true,
      };
    case leaveTypes.ADD_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS:
      return {
        ...state,
        comLeaveSettLoadings: false,
        comLeaveSettInfo: payload,
        comLeaveSettErrors: "",
      };
    case leaveTypes.ADD_LEAVE_SETTING_IN_ALL_COMPANY_FAIL:
      return {
        ...state,
        comLeaveSettLoadings: false,
        comLeaveSettErrors: payload,
        comLeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const getCompanyLeaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_LEAVE_SETTING_IN_ALL_COMPANY_REQUEST:
      return {
        ...state,
        getCompLeaveSettLoadings: true,
      };
    case leaveTypes.GET_LEAVE_SETTING_IN_ALL_COMPANY_SUCCESS:
      return {
        ...state,
        getCompLeaveSettLoadings: false,
        getCompLeaveSettInfo: payload,
        getCompLeaveSettErrors: "",
      };
    case leaveTypes.GET_LEAVE_SETTING_IN_ALL_COMPANY_FAIL:
      return {
        ...state,
        getCompLeaveSettLoadings: false,
        getCompLeaveSettErrors: payload,
        getCompLeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const addUserLeaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_SETTING_FOR_USER_REQUEST:
      return {
        ...state,
        addUserLeaveSettLoadings: true,
      };
    case leaveTypes.ADD_LEAVE_SETTING_FOR_USER_SUCCESS:
      return {
        ...state,
        addUserLeaveSettLoadings: false,
        addUserLeaveSettInfo: payload,
        addUserLeaveSettErrors: "",
      };
    case leaveTypes.ADD_LEAVE_SETTING_FOR_USER_FAIL:
      return {
        ...state,
        addUserLeaveSettLoadings: false,
        addUserLeaveSettErrors: payload,
        addUserLeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const updateUserLeaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LEAVE_USER_SETTING_REQUEST:
      return {
        ...state,
        updateUserLeaveSettingLoading: true,
      };
    case leaveTypes.ADD_LEAVE_USER_SETTING_SUCCESS:
      return {
        ...state,
        updateUserLeaveSettingLoading: false,
        updateUserLeaveSettingInfo: payload,
        updateUserLeaveSettingError: "",
      };
    case leaveTypes.ADD_LEAVE_USER_SETTING_FAIL:
      return {
        ...state,
        updateUserLeaveSettingLoading: false,
        updateUserLeaveSettingError: payload,
        updateUserLeaveSettingInfo: [],
      };
    default:
      return state;
  }
};

export const setApproverStagesForLeaveReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const setApproverStagesForLeaveDepartmentReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.SET_APPROVER_STAGES_FOR_LEAVE_DEPARTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const addWorkingIneaveSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_REQUEST:
      return {
        ...state,
        addWorkLeaveSettLoadings: true,
      };
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_SUCCESS:
      return {
        ...state,
        addWorkLeaveSettLoadings: false,
        addWorkLeaveSettInfo: payload,
        addWorkLeaveSettErrors: "",
      };
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_FAIL:
      return {
        ...state,
        addWorkLeaveSettLoadings: false,
        addWorkLeaveSettErrors: payload,
        addWorkLeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const addLateTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_LATE_TIME_REQUEST:
      return {
        ...state,
        addLateTimeLoadings: true,
      };
    case leaveTypes.ADD_LATE_TIME_SUCCESS:
      return {
        ...state,
        addLateTimeLoadings: false,
        addLateTimeInfo: payload,
        addLateTimeErrors: "",
      };
    case leaveTypes.ADD_LATE_TIME_FAIL:
      return {
        ...state,
        addLateTimeLoadings: false,
        addLateTimeErrors: payload,
        addLateTimeInfo: [],
      };
    default:
      return state;
  }
};

export const getLateTimeReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_REQUEST:
      return {
        ...state,
        getLateTimeLoadings: true,
      };
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_SUCCESS:
      return {
        ...state,
        getLateTimeLoadings: false,
        getLateTimeInfo: payload,
        getLateTimeErrors: "",
      };
    case leaveTypes.ADD_WORKING_IN_LEAVE_SETTING_FAIL:
      return {
        ...state,
        getLateTimeLoadings: false,
        getLateTimeErrors: payload,
        getLateTimeInfo: [],
      };
    default:
      return state;
  }
};

export const createPublicHolidaysReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.CREATE_PUBLIC_HOLIDAY_REQUEST:
      return {
        ...state,
        createPublicHolidaysLoading: true,
      };
    case leaveTypes.CREATE_PUBLIC_HOLIDAY_SUCCESS:
      return {
        ...state,
        createPublicHolidaysLoading: false,
        publicHolidays: payload,
        error: "",
      };
    case leaveTypes.CREATE_PUBLIC_HOLIDAY_FAIL:
      return {
        ...state,
        createPublicHolidaysLoading: false,
        publicHolidays: [],
      };
    default:
      return state;
  }
};
export const updatePublicHolidaysReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.UPDATE_PUBLIC_HOLIDAY_REQUEST:
      return {
        ...state,
        updatePublicHolidaysLoading: true,
      };
    case leaveTypes.UPDATE_PUBLIC_HOLIDAY_SUCCESS:
      return {
        ...state,
        updatePublicHolidaysLoading: false,
        publicHolidays: payload,
        error: "",
      };
    case leaveTypes.UPDATE_PUBLIC_HOLIDAY_FAIL:
      return {
        ...state,
        updatePublicHolidaysLoading: false,
        publicHolidays: [],
      };
    default:
      return state;
  }
};
export const getOnePublicHolidaysReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_ONE_PUBLIC_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.GET_ONE_PUBLIC_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        publicHolidays: payload,
        error: "",
      };
    case leaveTypes.GET_ONE_PUBLIC_HOLIDAY_FAIL:
      return {
        ...state,
        loading: false,
        publicHolidays: [],
        error: payload,
      };
    default:
      return state;
  }
};
export const getAllPublicHolidaysReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_ALL_PUBLIC_HOLIDAY_REQUEST:
      return {
        ...state,
        getAllPublicHolidaysloading: true,
      };
    case leaveTypes.GET_ALL_PUBLIC_HOLIDAY_SUCCESS:
      return {
        ...state,
        getAllPublicHolidaysloading: false,
        publicHolidays: payload,
        error: "",
      };
    case leaveTypes.GET_ALL_PUBLIC_HOLIDAY_FAIL:
      return {
        ...state,
        getAllPublicHolidaysloading: false,
        publicHolidays: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const deletePublicHolidaysReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.DELETE_PUBLIC_HOLIDAY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.DELETE_PUBLIC_HOLIDAY_SUCCESS:
      return {
        ...state,
        loading: false,
        publicHolidays: payload,
        error: "",
      };
    case leaveTypes.DELETE_PUBLIC_HOLIDAY_FAIL:
      return {
        ...state,
        loading: false,
        publicHolidays: [],
      };
    default:
      return state;
  }
};

export const createNewLeaveTypeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.CREATE_NEW_LEAVE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.CREATE_NEW_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.CREATE_NEW_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const getNewLeaveTypeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_NEW_LEAVE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.GET_NEW_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.GET_NEW_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const updateNewLeaveTypeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const updateNewLeaveTypeStatusReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.UPDATE_NEW_LEAVE_TYPE_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const archiveNewLeaveTypeReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.ARCHIVE_NEW_LEAVE_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.ARCHIVE_NEW_LEAVE_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.ARCHIVE_NEW_LEAVE_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const getAllLeaveRequestsReducer = (
  state = { loading: true },
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_ALL_LEAVE_REQUESTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.GET_ALL_LEAVE_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.GET_ALL_LEAVE_REQUESTS_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const getAllLeaveHistoryReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.GET_ALL_LEAVE_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case leaveTypes.GET_ALL_LEAVE_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case leaveTypes.GET_ALL_LEAVE_HISTORY_FAIL:
      return {
        ...state,
        loading: false,
        info: [],
      };
    default:
      return state;
  }
};

export const downloadLeaveRequestPdfReducer = (state = {}, action) => {
  switch (action.type) {
    case leaveTypes.DOWNLOAD_LEAVE_REQ_PDF_REQUEST:
      return { loading: true };
    case leaveTypes.DOWNLOAD_LEAVE_REQ_PDF_SUCCESS:
      return { loading: false, success: true };
    case leaveTypes.DOWNLOAD_LEAVE_REQ_PDF_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
export const downloadPublicHolidayXlsxReducer = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_XLSX_REQUEST:
      return {
        ...state,
        downloadPublicHolidayXlsxloading: true,
      };
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_XLSX_SUCCESS:
      return {
        ...state,
        downloadPublicHolidayXlsxloading: false,
        downloadPublicHolidayXlsxdata: payload,
        downloadPublicHolidayXlsxerror: "",
      };
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_XLSX_FAIL:
      return {
        ...state,
        downloadPublicHolidayXlsxloading: false,
        downloadPublicHolidayXlsxerror: payload,
        downloadPublicHolidayXlsxdata: null,
      };
    default:
      return state;
  }
};
export const downloadPublicHolidayCsvReducer = (state = {}, action) => {
  switch (action.type) {
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_CSV_REQUEST:
      return { loading: true };
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_CSV_SUCCESS:
      return { loading: false, success: true };
    case leaveTypes.DOWNLOAD_PUBLIC_HOLIDAY_CSV_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const individualLeaveApproversReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case leaveTypes.INDIVIDUAL_LEAVE_APPROVERS_REQUEST:
      return {
        ...state,
        individualLeaveApproversLoading: true,
      };
    case leaveTypes.INDIVIDUAL_LEAVE_APPROVERS_SUCCESS:
      return {
        ...state,
        individualLeaveApproversLoading: false,
        individualLeaveApproversInfo: payload,
        individualLeaveApproversError: "",
      };
    case leaveTypes.INDIVIDUAL_LEAVE_APPROVERS_FAIL:
      return {
        ...state,
        individualLeaveApproversLoading: false,
        individualLeaveApproversError: payload,
        individualLeaveApproversInfo: [],
      };
    default:
      return state;
  }
};
